// ============================================
// STATUS BADGE COMPONENT
// ============================================

import { cn, getStatusColor } from '@/utils';

interface StatusBadgeProps {
  status: string;
  label?: string;
  size?: 'sm' | 'default' | 'lg';
  dot?: boolean;
  className?: string;
}

// Status label translations
const statusLabels: Record<string, string> = {
  // User status
  ACTIVE: 'Aktif',
  INACTIVE: 'Pasif',
  SUSPENDED: 'Askıya Alındı',
  PENDING_VERIFICATION: 'Doğrulama Bekliyor',
  
  // Job status
  DRAFT: 'Taslak',
  PAUSED: 'Duraklatıldı',
  CLOSED: 'Kapatıldı',
  EXPIRED: 'Süresi Doldu',
  
  // Application status
  PENDING: 'Beklemede',
  REVIEWED: 'İncelendi',
  SHORTLISTED: 'Kısa Listede',
  INTERVIEW: 'Mülakat',
  OFFERED: 'Teklif Yapıldı',
  ACCEPTED: 'Kabul Edildi',
  REJECTED: 'Reddedildi',
  WITHDRAWN: 'Geri Çekildi',
  
  // Verification status
  IN_REVIEW: 'İnceleniyor',
  APPROVED: 'Onaylandı',
  
  // Boolean
  true: 'Evet',
  false: 'Hayır',
};

export function StatusBadge({
  status,
  label,
  size = 'default',
  dot = false,
  className,
}: StatusBadgeProps) {
  const displayLabel = label || statusLabels[status] || status;
  const colorClass = getStatusColor(status);

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px]',
    default: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        sizeClasses[size],
        colorClass,
        className
      )}
    >
      {dot && (
        <span
          className={cn(
            'mr-1.5 rounded-full',
            size === 'sm' ? 'h-1 w-1' : 'h-1.5 w-1.5',
            'bg-current opacity-70'
          )}
        />
      )}
      {displayLabel}
    </span>
  );
}

// ============================================
// VERIFICATION BADGE
// ============================================

interface VerificationBadgeProps {
  isVerified: boolean;
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

export function VerificationBadge({
  isVerified,
  size = 'default',
  className,
}: VerificationBadgeProps) {
  return (
    <StatusBadge
      status={isVerified ? 'APPROVED' : 'PENDING'}
      label={isVerified ? 'Doğrulanmış' : 'Doğrulanmamış'}
      size={size}
      dot
      className={className}
    />
  );
}
